import { Material, MaterialProperties } from '../../core/Material';
import * as THREE from 'three';

export interface PhysicalMaterialProperties extends MaterialProperties {
  color: string;
}

const properties: PhysicalMaterialProperties = {
  color: '#ffffff',
};

export const PhysicalMaterialItem: Material = {
  id: '',
  name: 'Physical Material',
  type: 'material',
  subtype: 'physical',
  properties: properties,
  fields: [
    {
      key: 'properties.color',
      type: 'color',
      label: 'Color',
      default: '#ffffff',
      panel: 'material',
    },
  ],
  render: (props) => {
    const { color } = props;
    return new THREE.MeshPhysicalMaterial({ color });
  },
};
